import { APP } from '../../redux/constants/app.constants';

export const PRESENTATION_PAGE = `${APP}/PRESENTATION_PAGE`;

export const LOGIN_PRESENTATION = `${PRESENTATION_PAGE}/LOGIN_PRESENTATION`;
export const SET_OPTIONS = `${PRESENTATION_PAGE}/SET_OPTIONS`;
export const GET_OPTIONS = `${PRESENTATION_PAGE}/GET_OPTIONS`;
export const SET_PAGE_TYPE = `${PRESENTATION_PAGE}/SET_PAGE_TYPE`;